<template>
    <div>
        <section class="folders-section section pb-4">
            <p class="is-size-4">{{ $t('hi') }}&nbsp;{{ user.name }}&nbsp;{{ user.surname }}</p>
        </section>
        <div class="section">
            <div class="columns is-mobile">
                <div class="column is-9">
                    <div class="columns is-mobile is-vcentered profile-data">
                        <div class="column is-narrow has-text-centered">
                            <p class="is-size-5 pb-2">{{  $t('profile_image') }}</p>
                            <div :style="getBackground"></div>
                        </div>
                        <div class="column has-text-centered"></div>
                        <div class="column" v-if="showEntityAlert">
                            <div class="notification is-warning">
                                <p class="secondary-font" v-html="$t('eduloc360_base_entity_alert')"></p>
                            </div>
                        </div>
                    </div>
                    <div class="columns is-mobile is-vcentered profile-data">
                        <div class="column is-narrow">
                            <p class="is-size-5 pb-2">{{  $t('profile_full_name') }}</p>
                            <p class="secondary-font" >{{ user.name }}&nbsp;{{ user.surname }}</p>
                        </div>
                        <div class="column has-text-centered"></div>
                        <div class="column is-narrow has-text-centered">
                        </div>
                    </div>
                    <div class="columns is-mobile is-vcentered profile-data">
                        <div class="column is-narrow">
                            <p class="is-size-5 pb-2">{{  $t('profile_email') }}</p>
                            <p class="secondary-font" >{{ user.email }}</p>
                        </div>
                        <div class="column has-text-centered"></div>
                        <div class="column is-narrow has-text-centered">
                        </div>
                    </div>
                    <div v-if="user.type=='LOCAL'" class="columns is-mobile is-vcentered profile-data">
                        <div class="column is-narrow">
                            <p class="is-size-5 pb-2">{{  $t('profile_username') }}</p>
                            <p class="secondary-font" >{{ user.username }}</p>
                        </div>
                        <div class="column has-text-centered"></div>
                        <div class="column is-narrow has-text-centered">
                            <button  class="button is-eduloc-red is-block is-fullwidth" @click="editProfile">{{ $t('profile_edit_all') }}</button>
                        </div>
                    </div>

                    <div v-if="user.type!='LOCAL'" class="columns is-mobile is-vcentered">
                        <div class="column is-12">
                            <p class="is-size-5 pb-2">{{  $t('profile_login_service') }}</p>
                        </div>
                    </div>
                    <div v-if="user.type!='LOCAL'" class="columns is-mobile is-vcentered is-bordered">
                        <div class="column is-narrow is-bordered ml-4">
                            <figure class="image is-24x24 " >
                                <img v-if="user.type=='GOOGLE'" class="is-square"  :src="require('@/assets/images/logo_google.png')"/>
                                <img v-else class="is-square"  :src="require('@/assets/images/logo_microsoft.png')"/>
                            </figure>
                        </div>
                        <div class="column is-narrow">
                            <p class="pb-0">{{  $t(user.type) }}</p>
                            <p class="secondary-font" >{{ user.name }}&nbsp;{{ user.surname }}</p>
                        </div>
                        <div class="column has-text-centered"></div>
                        <div class="column is-narrow has-text-centered">
                            <button @click="unlinkUser" class="button unlink is-fullwidth">{{ $t('profile_unlink') }}</button>
                        </div>
                    </div>
                </div>
            </div>
            

            <div class="pt-4">
                <button class="button is-eduloc-red is-block my-4" :disabled="activePlan && activePlan.shortCode!='FREE_PLAN'" @click="removeUser">{{ $t('profile_remove') }}</button>
                <p class="secondary-font">
                    {{ $t('profile_remove_desc') }}
                </p>
                <p class="secondary-font" v-if="activePlan && activePlan.shortCode!='FREE' && !hasSchool">
                    {{ $t('profile_remove_disabled') }}
                </p>
                <p class="secondary-font" v-if="hasSchool && !isCoordinator">
                    {{ $t('profile_remove_entity__disabled') }}
                </p>
                <p class="secondary-font" v-if="hasSchool && isCoordinator">
                    {{ $t('profile_remove_entity__disabled_coordinator') }}
                </p>
                <p class="secondary-font">
                    {{ $t('profile_registered_at') }}&nbsp;{{ $options.filters.createdDate(user.created) }}.
                </p>
            </div>			
        </div>
        <UserProfileModal v-if="editing || unlink" @close="closeModal" :user="user" :unlink="unlink"></UserProfileModal>
    </div>
</template>

<script>
import { fetchMyProjectsInfo, removeMyUser } from '@/services/API';
import NProjectsGrid from '@/components/NProjectsGrid';
import UserProfileModal from '@/components/UserProfileModal';
import _ from 'underscore';
import moment from 'moment';
import { AVAILIABLE_PROJECT_TYPES } from '@/lib/constants';
import Swal from 'sweetalert2';
export default {
    components: {
        NProjectsGrid,
        UserProfileModal
    },
    props: {},
    data() {
        return {
            projectsData: {},
            editing: false,
            unlink: false,
        };
    },
    filters: {
        createdDate(timestamp) {
            return moment(timestamp).format('DD/MM/YYYY');
        },
    },
    computed: {
        user() {
            return this.$store.getters.user;
        },
        avatar() {
            return this.$store.getters.user.avatar;
        },
        activePlan() {
            return this.$store.getters.activePlan;
        },
        projectTypes() {
            return AVAILIABLE_PROJECT_TYPES;
        },
        hasSchool() {
            return this.$store.getters.hasSchool;
        },
        isCoordinator() {
            return this.$store.getters.hasSchool && this.$store.getters.canManageSchool;
        },
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        canManageSuscription() {
            if (this.$store.getters.canManageSchool || (!this.$store.getters.hasSchool && (this.$store.getters.activePlan && this.$store.getters.activePlan.shortCode != 'FREE_PLAN')) ) {
                return true;
            } 
            return false;
        },
        getBackground() {
            if (this.avatar) {
                return `background-image:url(${this.avatar});background-size:cover; background-repeat: no-repeat; background-position: center;height: 128px;border-radius: 50%;width: 128px;margin: 0 auto;`;
            }
            return `background-image:url('${this.defaultImage}');background-size:cover; background-repeat: no-repeat; background-position: center;height: 128px;border-radius: 50%;width: 128px;margin: 0 auto;`;
        },
        defaultImage(){
            return "/img/usuari.png";
        },
        haveAppPage() {
            if (this.$store.getters.activePlan && this.$store.getters.activePlan.configuration) {
                return this.$store.getters.activePlan.configuration.general.appPage;
            }
            return false;
        },
        isCoordinator() {
            return this.$store.getters.hasSchool && this.$store.getters.canManageSchool;
        },
        showEntityAlert() {
            if (this.$store.getters.hasSchool && this.$store.getters.school.name == 'EDULOC360' && !this.isCoordinator) {
                return true;
            }
            return false;
        },
    },
    async mounted() {
        if (this.$route.query && this.$route.query.plan) {
            //alert(this.$route.query.plan)
            if (this.user.email) {
                let email = encodeURI(this.user.email);
                let encoded=window.btoa(email)
                if (email) {
                    // console.log("redirecting froum mounted")
                    setTimeout(function () { 
                        if (this.user && this.user.plan) {
                            if (this.user.plan.shortCode == this.$route.query.plan) {
                                Swal.fire({
                                    title: this.$t('same_plan_subscription_title'),
                                    text: this.$t('same_plan_subscription_message'),
                                    showCancelButton: false,
                                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                                }).then((result) => {
                                    console.log("same plan")
                                });
                                // missatge mateix pla
                            }
                        } else if (this.user.school) {
                            Swal.fire({
                                    title: this.$t('has_pro_plan_subscription_title'),
                                    text: this.$t('has_pro_plan_subscription_message'),
                                    showCancelButton: false,
                                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                                }).then((result) => {
                                    console.log("has pro plan")
                                });
                            // missatge pla pro
                        } else {
                            switch (this.$route.query.plan) {
                                case "PREMIUM_PLAN":
                                    // console.log("encoded",encoded)
                                    window.location.href = `https://buy.stripe.com/test_5kQ6oI00G2cz4Kr4jVfIs00?locale=es&client_reference_id=${this.user._id}&prefilled_email=${email}`;
                                    break;
                                case "EXPERT_PLAN":
                                    // console.log("encoded",encoded)
                                    window.location.href = `https://buy.stripe.com/test_dRm3cwaFk8AX0ubcQrfIs01?locale=es&client_reference_id=${this.user._id}&prefilled_email=${email}`;
                                    break;
                            }
                        }

                        
                    
                }, 200);
                }
            }
            
        }
        let items = await fetchMyProjectsInfo();
        if (items.data) {
            this.projectsData=items.data
        }
        // console.log(this.projectsData)
       
                

    },
    watch: {
        user: {
            handler: function (newValue) {
                
                if (newValue.plan) {
                    if (this.$route.query && this.$route.query.plan) {
                        // console.log(newValue.plan.shortCode, this.$route.query.plan)
                        let email = encodeURI(newValue.email);
                        if (newValue.plan.shortCode == this.$route.query.plan) {
                            Swal.fire({
                                title: this.$t('same_plan_subscription_title'),
                                text: this.$t('same_plan_subscription_message'),
                                showCancelButton: false,
                                confirmButtonText: this.$t('userProfile.leave_school_continue'),
                            }).then((result) => {
                                console.log("same plan")
                            });
                            // missatge mateix pla
                        } else if (newValue.school) {
                            Swal.fire({
                                title: this.$t('has_pro_plan_subscription_title'),
                                text: this.$t('has_pro_plan_subscription_message'),
                                showCancelButton: false,
                                confirmButtonText: this.$t('userProfile.leave_school_continue'),
                            }).then((result) => {
                                console.log("has pro plan")
                            });
                            // missatge pla pro
                        } else {
                            switch (this.$route.query.plan) {
                                case "PREMIUM_PLAN":
                                    // console.log("encoded",encoded)
                                    // console.log("refirecting")
                                    window.location.href = `https://buy.stripe.com/test_5kQ6oI00G2cz4Kr4jVfIs00?locale=es&client_reference_id=${newValue._id}&prefilled_email=${email}`;
                                    break;
                                case "EXPERT_PLAN":
                                    // console.log("refirecting")
                                    // console.log("encoded",encoded)
                                    window.location.href = `https://buy.stripe.com/test_dRm3cwaFk8AX0ubcQrfIs01?locale=es&client_reference_id=${newValue._id}&prefilled_email=${email}`;
                                    break;
                            }

                        }
                    }
                    
                }
                
            },
            immediate: true,
        },
        
        /*user: function (newValue) {
            console.log("checking watch")
            if (this.$route.query && this.$route.query.plan && newValue.email) {
                console.log("email", newValue.email)
                let email = encodeURI(newValue.email);
                console.log("redirecting froum watch")
                let encoded=window.btoa(email)
                setTimeout(function () { 

                    console.log("encoded", encoded)
                    //this.checkPlan(newValue);
                    //window.location.href = `https://buy.stripe.com/test_5kQ6oI00G2cz4Kr4jVfIs00?locale=es&client_reference_id=${newValue._id}&prefilled_email=${email}`;
                    this.$emit



                }, 200);
                
            }
        }*/
    },
    methods: {
        checkPlan(newValue) {
            if (newValue.plan) {
                        if (newValue.plan.shortCode == this.$route.query.plan) {
                            Swal.fire({
                                title: this.$t('same_plan_subscription_title'),
                                text: this.$t('same_plan_subscription_message'),
                                showCancelButton: false,
                                confirmButtonText: this.$t('userProfile.leave_school_continue'),
                            }).then((result) => {
                                console.log("same plan")
                            });
                            // missatge mateix pla
                        }
                    }

                    if (newValue.school) {
                        Swal.fire({
                                title: this.$t('has_pro_plan_subscription_title'),
                                text: this.$t('has_pro_plan_subscription_message'),
                                showCancelButton: false,
                                confirmButtonText: this.$t('userProfile.leave_school_continue'),
                            }).then((result) => {
                                console.log("has pro plan")
                            });
                        // missatge pla pro
                    }

                    switch (this.$route.query.plan) {
                        case "PREMIUM_PLAN":
                            // console.log("encoded",encoded)
                            window.location.href = `https://buy.stripe.com/test_5kQ6oI00G2cz4Kr4jVfIs00?locale=es&client_reference_id=${newValue._id}&prefilled_email=${email}`;
                            break;
                        case "EXPERT_PLAN":
                            // console.log("encoded",encoded)
                            window.location.href = `https://buy.stripe.com/test_dRm3cwaFk8AX0ubcQrfIs01?locale=es&client_reference_id=${newValue._id}&prefilled_email=${email}`;
                            break;
                    }
        },
        editProfile() {
            if (this.editing) {
                return;
            }
            this.editing = true;
        },
        removeUser() {
            if (this.$store.getters.activePlan.shortCode != 'FREE_PLAN') {
                return;
            }
            Swal.fire({
                title: this.$t('remove_my_user_alert_title'),
                text: this.$t('remove_my_user_alert_text'),
                showCancelButton: true,
                confirmButtonColor: '#cc1e4a',
                cancelButtonColor: '#afafaf',
                confirmButtonText: this.$t('userProfile.leave_school_continue'),
                cancelButtonText: this.$t('userProfile.leave_school_cancel'),
            }).then((result) => {
                if (result.isConfirmed) {
                    this.deleteUser();
                }
            });
        },
        async deleteUser() {
            // console.log("removing user")
            let error = false;
            await removeMyUser()
            .catch((e) => {
                Swal.fire({
                    title: this.$t('Error.' + e.status),
                    text: this.$t('Error.MY_' + e.data),
                    showCancelButton: false,
                    confirmButtonText: this.$t(
                        'userProfile.leave_school_cancel'
                    ),
                    confirmButtonColor: '#d33',
                });
                error = true;
                return;
            })
            .finally(() => {
                if (!error) {
                    
                    let email = encodeURI(this.user.email);
                    let created = encodeURI(moment(this.user.created).format('DD/MM/YYYY'));
                    // console.log(email, created);
                    this.$store.dispatch('logout');
                    setTimeout(function () {
                        window.location.href=`https://www.eduloc360.com/feedback-usuario?email=${email}&created=${created}`;
                    }, 200);
                }
            });
        },
        unlinkUser() {
            if (this.unlink) {
                return;
            }
            this.unlink = true;
        },
        closeModal() {
            this.unlink = false;
            this.editing = false;
        }
    },
};
</script>

<style scoped>
.plan-features-list{
    list-style: none;
    background-color: #f9f9f9;
}
.plan-text{
    vertical-align: bottom;
}
.plan-features-title{
    background-color: var(--eduloc-red);
    color: #FFFFFF;
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
    font-size: 1.4rem;
    text-transform: uppercase;
}
.plan-features-footer{
    background-color: var(--eduloc-blue);
    color: #FFFFFF;
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
    font-size: 1.4rem;
    text-transform: uppercase;
}
.plan-data-header{
    background-color: var(--eduloc-blue);
    color: #FFFFFF;
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
    font-size: 1.4rem;
    text-transform: uppercase;
    white-space: nowrap;
}
.plan-data-content{
    border-style: solid;
    border-width: 2px;
    border-color: var(--eduloc-blue);
    text-align: center;
}
.theader{
    background-color: var(--eduloc-grey);
}
.plan-data-content td{
    white-space: nowrap;
}


.profile-data.columns{
    border-bottom: 1px solid var( --eduloc-grey-light)
}
.columns.is-bordered, .column.is-bordered{
    border: 1px solid var( --eduloc-grey-light);
    border-radius: 4px;
}
.button.unlink:hover{
    color:var(--eduloc-red)
}

</style>